import axios, { AxiosError } from "axios";

const baseUrl: string = "/api/v0/invites";

export interface Invite {
    id: string;
    inviteDate: string;
    expiration?: string | null;
    expired?: boolean;
    inviterId: string;
    userName: string;
    accountId: string;
    used?: boolean;
    token: string;
}

export interface CreateInviteModel {
    accountId: string;
    inviteDate: string;
    inviterId: string;
    userName: string;
    expiration: string | null
}

export interface InviteApi {
    getInvites: () => Promise<Invite[]>;
    getInvite: (token: string) => Promise<Invite | null>;
    createInvite: (accountId: string, userName: string, expiration?: string) => Promise<string>;
    deleteInvite: (inviteId: string) => Promise<void>;
}

const inviteApi: InviteApi = {
    getInvites: async () => {
        const { data } = await axios.get(baseUrl);
        return data;
    },

    getInvite: async (token: string) => {
        const { data } = await axios.get<Invite | null>(`${baseUrl}/${token}`);
        return data;
    },

    createInvite: async (accountId: string, userName: string, expiration?: string) => {
        const { data } = await axios.post(`${baseUrl}/${accountId}`, ({
            userName: userName,
            expiration: expiration,
        }));

        return data;
    },

    deleteInvite: async (inviteId: string) => await axios.delete(`${baseUrl}/${inviteId}`),
};

export default inviteApi;